module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/tmf-logo.svg"),
      "alt": "Track My FCEV"
    }
  })]), _vm._v(" "), (_vm.app.isLoading) ? _c('i', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "loading--internal"
  })]) : _vm._e(), _vm._v(" "), (_vm.getToken()) ? _c('div', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.app.user.first_name) + " " + _vm._s(_vm.app.user.last_name) + " "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('li', {
    staticClass: "el-dropdown-menu__item",
    on: {
      "click": _vm.profile
    }
  }, [_vm._v("\n\t\t\t\t\t\tProfile\n\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "el-dropdown-menu__item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n\t\t\t\t\t\tLogout\n\t\t\t\t\t")])])], 1)], 1) : _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Register'
      }
    }
  }, [_vm._v("Register")])], 1)], 1), _vm._v(" "), (_vm.getToken()) ? _c('nav', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Analysis'
      }
    }
  }, [_vm._v("Analysis")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'History'
      }
    }
  }, [_vm._v("Fuelling History")])], 1) : _vm._e(), _vm._v(" "), _c('main', [(_vm.app.messages.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, _vm._l((_vm.app.messages), function(message, index) {
    return _c('el-alert', {
      key: index,
      attrs: {
        "title": message,
        "type": "info",
        "show-icon": ""
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('footer', [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.cenex.co.uk/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAbout Cenex\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Terms'
      }
    }
  }, [_vm._v("Terms & Conditions")])], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12
    }
  }, [_c('p', [_vm._v("\n\t\t\t\t\t© 2017 Cenex\n\t\t\t\t")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55fdde36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 632
// module chunks = 1